module.exports = __webpack_public_path__ + "static/media/photo2.50189c08.png";